import { css } from 'emotion';
import { space } from '@joykit';

export namespace styles {
  export const container = css({
    margin: '48px auto 16px',
    width: '500px',
    maxWidth: '90%',
    textAlign: 'center'
  });
  export const message = css({
    fontSize: '18px',
    fontFamily: 'PT serif',
    margin: space.stack.md,
    textAlign: 'center',
    lineHeight: '36px'
  });

  export const filterButton = css({
    borderBottom: '1px solid',
    lineHeight: '24px'
  });
}
